var mqMath = {
  valid: function(width, height) {
    return Number.isFinite(width) && Number.isFinite(height) &&
      width > 0 && height > 0 && Math.min(width, height) <= 118;
  },
  areaUnits: function(width, height) { return Math.ceil(width * height); },
  bindingUnits: function(width, height, kind, discounted) {
    var units = width * height < 1000 && kind === 'machine' ? 40 : 2 * (width + height);
    return Math.ceil(units / (discounted ? 2 : 1));
  },
  // Backing extends 4" past every side. Up to 100" wide that is one length of the longest side; wider
  // quilts get two widths of 108" fabric seamed together, each as long as the shortest side.
  seamed: function(width, height) { return Math.min(width, height) + 8 > 108; },
  backingUnits: function(width, height) {
    var length = this.seamed(width, height) ? 2 * (Math.min(width, height) + 8) : Math.max(width, height) + 8;
    return Math.ceil(length / 9);
  },
  backingFits: function(width, height, fabricWidth, inventory) {
    var fits = this.seamed(width, height)
      ? fabricWidth === 108 && Math.max(width, height) + 8 <= 2 * fabricWidth
      : Math.min(width, height) + 8 <= fabricWidth;
    return this.valid(width, height) && fits && inventory >= this.backingUnits(width, height);
  }
};
// End shared calculation helpers. Prices remain supplied by the configured Shopify variants.

// const qChoice = { name: "Quilters Choice" , type: 'standard', value: 'quilters_choice' };

const mq_order_id = Math.floor(Math.random() * 100000);

var backingIncluded = "Included";
var backingIncText = "I'm including my own backing";

var selectedPattern = null; // { name: '', image: '', price: '', variantId: '', type: '', themes: ''}
var selectedThread = { name: "Quilters Choice" , type: 'standard', value: 'quilters_choice' }; // String // WIP { name : '', type: '', value: '' }

var selectedBatting = null; // { name: '', image: '', price: '', variantId: ''}

var selectedBacking = null; // { name: '', image: '', price: '', variantId: ''}
var fbyBackingQty = 0;
var selectedStitching = "no"; // String: 'no' | 'yes'
// var backStitchingPrice = 15;

var selectedBinding = "none"; // String: 'none' | 'trim' | 'machine' | 'hand'

// TODO these are now defaults if the template doesn't provide info
// var machineBindingPrice = 45; // USD
// var handBindingPrice = 105; // USD
// var trimmingPrice = 10; // USD

// Priority Quilting
var selectedExpOption = false;
var selectedDeluxePattern = false;
var selectedSocialSharing = false;

var selectedChuckDiscount = false; // two cent patterns
var selectedPennyPattern = false; // penny patterns
var table_topper = false;

// Updated pricing per inch
var value_standard = 0.03;
var value_deluxe = 0.005;

var priority_standard = 0.035;
var priority_deluxe = 0.0025;

// default no discount on any pattern
// will change is patterns are discounted and selected pattern matches discounted theme
var pattern_is_discounted = false;

// Validation
var validPatternMsg = "Please select a valid Pattern<br>";
var validDimensionsMsg = "Please enter valid dimensions for your quilt (width and height) in inches<br>";
var validBattingMsg = "Please choose your Batting<br>";
var validBackingMsg = "Please make a selection for Backing<br>";
var validTermsAgree = "Please agree to the terms<br>";

// var priorityId = 34861283934341; // priority cost, 7 cents / 2 sq inches
// var backStitchingId =  34821461442693;

// var machineBindingId = 34799491776645;
// var handBindingId = 34799491809413;
// var trimBindingId = 39269086068869;

//var deluxeId = 39661473497221;

$(document).ready(function(){

  function initializeThreadWheel() {
    $("#colorwheel-select").colorwheel();
    $('#colorwheel-select .segment').each(function() {
      $(this).attr({ role: 'button', tabindex: '0', 'aria-label': $(this).find('path').attr('label') });
    });
  }
  initializeThreadWheel();

  // The wheel keeps its existing click/selection path, including after a reset.
  $('#colorwheel-select').on('keydown', '.segment', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  let openDialog = null;
  let dialogTrigger = null;
  let dialogOverflow = '';
  let inertSiblings = [];

  function dialogControls() {
    return $(openDialog).find('button, input, select, textarea, a[href], [tabindex="0"]')
      .filter(':visible').filter(function() { return !this.disabled && !this.closest('[inert]'); }).toArray();
  }

  function openMqDialog(id, trigger) {
    openDialog = document.getElementById(id);
    dialogTrigger = trigger;
    dialogOverflow = document.body.style.overflow;
    $(openDialog).removeClass('hidden');
    // Isolate only siblings of this dialog and its ancestors, preserving their prior state.
    for (let node = openDialog; node.parentElement && node !== document.body; node = node.parentElement) {
      for (const sibling of node.parentElement.children) {
        if (sibling !== node && !sibling.inert) {
          sibling.inert = true;
          inertSiblings.push(sibling);
        }
      }
    }
    document.body.style.overflow = 'hidden';
    (dialogControls()[0] || openDialog.querySelector('[role="dialog"]')).focus();
  }

  function closeMqDialog(id) {
    $('#' + id).addClass('hidden');
    if (!openDialog || openDialog.id !== id) return;
    inertSiblings.forEach(function(node) { node.inert = false; });
    inertSiblings = [];
    document.body.style.overflow = dialogOverflow;
    openDialog = null;
    dialogTrigger.focus({ preventScroll: true });
  }

  $(document).on('keydown', function(event) {
    if (!openDialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      $(openDialog).find('#close-pattern-dialog, #close-backing-dialog, #close-batting-dialog, .close-modal').first().trigger('click');
    } else if (event.key === 'Tab') {
      const controls = dialogControls();
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) {
        event.preventDefault();
      } else if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  });


  // Hide priority quilting pricing if free priority upgrade metafield checked
  if(priority_free == true){
    $('#expedite-cost').addClass('hidden')
  }

  $('#width, #height').keyup(function() {
    let topper_width = $('#width').val();
    let topper_height = $('#height').val();

    if((topper_width * topper_height) > 0 && (topper_width * topper_height) < 1000) {
      $('.topperNotice').removeClass('hidden');
    }else{
      $('.topperNotice').addClass('hidden');
    }
  });

  $('#width, #height').change(function() {
    updatePrice();
    updateBackingOptions();
  });

  if (sessionStorage.getItem('hp_mq_width') !== null || sessionStorage.getItem('hp_mq_height') !== null) {
    $('#width').val(sessionStorage.getItem('hp_mq_width'));
    $('#height').val(sessionStorage.getItem('hp_mq_height'));
    $('#width, #height').trigger('change');
    sessionStorage.removeItem('hp_mq_width');
    sessionStorage.removeItem('hp_mq_height');
  }



  let pattern_type = '';

  // PATTERN SELECTION
  $(".pattern-select").click(function(e){
    //show correct collection
    if($(this).data('pattern') === 'standard') {
      pattern_type = 'standard';
      $('ul#standard-patterns').removeClass('hidden');
    }else{
      pattern_type = 'deluxe';
      $('ul#permium-patterns').removeClass('hidden');
    }

    //open dialog
    openMqDialog('pattern-select-dialog', this);

    // populate pattern theme dropdown
    let theme_list = []

    $('#pattern-select-dialog ul:visible li').each(function() {
        let theme_search = this.dataset.themes.split(',');

        if(theme_search.length > 0) {

            for(let t = 0; t < theme_search.length; t++) {
                if (theme_search[t].length && !theme_list.includes(theme_search[t])){
                    theme_list.push(theme_search[t]);
                }
            }

        }
    });

    if (theme_list.length > 0) {
        const theme_select = document.getElementById('pattern_themes');
        theme_list = theme_list.sort();
        for( let t = 0; t < theme_list.length; t++){
            let option = document.createElement('option');
            let current_theme = theme_list[t];

            option.value = current_theme;
            option.text = current_theme;

            theme_select.add(option);
        }
    }

  });

  $("#close-pattern-dialog").click(function(){
      closeMqDialog('pattern-select-dialog');
      $("#pattern-options ul").addClass("hidden");
      $('#pattern-options li').show();
      $('#pattern_themes').empty().append('<option value="all">All Themes</option>');
      $('#pattern_themes').val('all');

  });

  // Upon selecting a pattern option in the dialog, set it as the selectedPattern.
  $( "li.pattern-option" ).each(function(index) {
      $(this).on("click", function(){
        selectedPattern = {
          name: $(this).data("name"),
          image: $(this).data("image"),
          price: $(this).data("price"),
          type: $(this).data("type"),
          tags: $(this).data("tags"),
          themes: $(this).data("themes"),
          variantId: $(this).data("variant")
        };

        // two cent discount
        if(selectedPattern.tags.includes('ChuckSale') || selectedPattern.tags.includes('TwoCentPattern')) {
          selectedChuckDiscount = true;
        }else{
          selectedChuckDiscount = false;
        }

        // PennyPattern Discount
        if(selectedPattern.tags.includes('PennyPattern')) {
          selectedPennyPattern = true;
        }else{
          selectedPennyPattern = false;
        }

        if($(this).attr("data-type") === 'deluxe'){
          selectedDeluxePattern = true;
        }else{
          selectedDeluxePattern = false;
        }

        updatePrice();

        $("#pattern-options ul").addClass("hidden");
        $('#pattern-options li').show();
        $('#pattern_themes').empty().append('<option value="all">All Themes</option>');
        $('#pattern_themes').val('all');

        // Show the user what they have selected.
        if(pattern_type === 'standard'){
          $("#pattern-select-text").html("Selected Standard Pattern<br>" + selectedPattern.name);
          $("#selected-pattern-image").attr("src", selectedPattern.image);
          $("#selected-pattern-image").removeClass("hidden");
        }else{
          $("#pattern-select-text").text($('#pattern-select').data('pattern-label'));
          $("#selected-pattern-image").attr("src", '');
          $("#selected-pattern-image").addClass("hidden");
        }

        if(pattern_type === 'deluxe'){
          $("#pattern-premium-select-text").html("Selected Deluxe Pattern<br>" + selectedPattern.name);
          $("#selected-pattern-premium-image").attr("src", selectedPattern.image);
          $("#selected-pattern-premium-image").removeClass("hidden");
        }else{
          $("#pattern-premium-select-text").text($('#pattern-premium-select').data('pattern-label'));
          $("#selected-pattern-premium-image").attr("src", '');
          $("#selected-pattern-premium-image").addClass("hidden");
        }

        closeMqDialog('pattern-select-dialog');
      });
  });

  // standard/colorwheel thread modal
  $('#thread-standard-select').on('click', function(){
    openMqDialog('standard-thread-select-dialog', this);
  });

  // colorPicker segment selection:
  $(document).on("click",".segment",function(event){
    event.preventDefault();

    $("input#clear-thread").prop("checked", false);
    var colorValue = $("#colorwheel-select").colorwheel('value');
    selectedThread.name = colorValue.label;
    selectedThread.type = 'standard';
    selectedThread.value = colorValue.value;
    
    // Show the user what they have selected.
    $(".thread-select-text").html("Selected Thread: " + colorValue.label);
    $('.thread-standard-display').removeClass('hidden').css("background-color", '#' + colorValue.value);

    updatePrice();
    closeMqDialog('standard-thread-select-dialog');
    //$("#selected-thread").removeClass("hidden");
    //$("#clear-thread span").removeClass("hidden");
  });

  $("#clear-thread").click(function(){
    selectedThread = { name: "Quilters Choice" , type: 'standard', value: 'quilters_choice' };

    updatePrice();
    thread_defaults('.thread-select-text', $('#thread-standard-select').data().threadLabel, '.thread-standard-display');

    initializeThreadWheel();
  });

  function thread_defaults(target, txt_source, img_container){
    $(target).html(txt_source);
    $(img_container).addClass('hidden');
  }

  // close an open modal if id ends with `-dialog`
  $('.close-modal').on('click', function() {
    closeMqDialog($(this).closest('div[id*="-dialog"]').attr('id'));
  });

  // BATTING SELECTION
  $("#batting-select").click(function(){
      //open dialog
      $('#batting-select-dialog').removeClass("hidden"); //toggleModal( $("#batting-modal-dialog") );
      document.body.style.overflow = 'hidden';
  });

  $("#close-batting-dialog").click(function(){
      $('#batting-select-dialog').addClass("hidden"); //toggleModal( $("#batting-modal-dialog") );
      document.body.style.overflow = '';
  });

  // Upon selecting a batting option in the dialog, set it as the selectedBatting.
  $( "li.batting-option" ).each(function(index) {
      $(this).on("click", function(){
        selectedBatting = {
          name: $(this).attr("data-name"),
          image: $(this).attr("data-image"),
          price: $(this).attr("data-price"),
          variantId: $(this).attr("data-variant")
        };
        $('#batting-select-dialog').addClass("hidden"); //toggleModal( $("#batting-modal-dialog") );
        document.body.style.overflow = '';

        // Show the user what they have selected.
        $("#batting-select-text").html("Selected Batting:<br>" + selectedBatting.name);
        $("#selected-batting-image").attr("src", selectedBatting.image);
        $("#selected-batting-image").removeClass("hidden");

      });
  });

  // BACKING SELECTION
  $("#backing-select").click(function(){
      //open dialog
      openMqDialog('backing-select-dialog', this); //toggleModal( $("#backing-modal-dialog") );
  });

  $("#close-backing-dialog").click(function(){
      closeMqDialog('backing-select-dialog');
  });

  // Upon selecting a backing option in the dialog, set it as the selectedBacking.
  $( "li.backing-option" ).on('click', function(index) {
      //$(this).on("click", function(){
        selectedBacking = {
          name: $(this).attr("data-name"),
          image: $(this).attr("data-image"),
          price: $(this).attr("data-price"),
          variantId: $(this).attr("data-variant"),
          width: Number(($(this).closest('[id^="backing-"]').attr('id') || '').replace('backing-', '')),
          inventory: Number($(this).attr('data-qty'))
        };

        updatePrice();

        // Show the user what they have selected.
        $("#backing-select-text").html("Selected Backing:<br>" + selectedBacking.name);
        $("#selected-backing-image").attr("src", selectedBacking.image);
        $("#selected-backing-image").removeClass("hidden");
        $("#clear-backing").removeClass("hidden");

        $("#back-stitching-select").addClass("hidden");
        closeMqDialog('backing-select-dialog');

      //});
  });

  $("#clear-backing").click(function(){
    selectedBacking = backingIncluded;
    fbyBackingQty = 0;
    $("#backing-select-text").html(backingIncText);
    $("#clear-backing").addClass("hidden");
    $("#selected-backing-image").addClass("hidden");
    $("#back-stitching-select").removeClass("hidden");
    $("#backing-select").trigger("focus");
    updatePrice();
  });

  function updatePrice(){
    var width = +$("#width").val();
    var height = +$("#height").val();

    if (!mqMath.valid(width, height)) {
      $(".current_price").text("—");
      return;
    }
    if (selectedBacking && selectedBacking !== backingIncluded &&
        !mqMath.backingFits(width, height, selectedBacking.width, selectedBacking.inventory)) {
      selectedBacking = null;
      $("#backing-select-text").text("Choose a backing that fits your quilt");
      $("#selected-backing-image").addClass("hidden");
      $("#clear-backing").removeClass("hidden");
    }
    var quilt_sq_in = width * height;

    // Set prices for machine/hand stitched binding
    var machine_stitch_price = $('input#machine').data('price');
    var hand_stitch_price = $('input#hand').data('price');
    var machine_stitch_total,
        hand_stitch_total;
    
    var price = mqMath.areaUnits(width, height) * base_price; // default pricing

    if(selectedChuckDiscount){
      price = Math.ceil(quilt_sq_in) * twocent_price; // chuck/two cent pattern discount
    }else if(selectedPennyPattern){
      price = Math.ceil(quilt_sq_in) * penny_price; // penny pattern discount
    }
    
    if(quilt_sq_in < 1000) {
      table_topper = true;
      price = table_topper_price;
    } else {
      table_topper = false;
    }

    machine_stitch_total = mqMath.bindingUnits(width, height, "machine", bindingDiscount) * machine_stitch_price;
    hand_stitch_total = mqMath.bindingUnits(width, height, "hand", bindingDiscount) * hand_stitch_price;

    $('span.machine_stitch_binding').text(Shopify.formatMoney(machine_stitch_total))
    $('span.hand_stitch_binding').text(Shopify.formatMoney(hand_stitch_total))

    if(selectedThread.type == 'variegated'){
      price += variegated_price;
    }

    if(selectedBinding == 'trim'){
      price += trimmingPrice;
    } else if(selectedBinding == 'machine'){
      // price += machineBindingPrice;
      price += (machine_stitch_total / 100);
    } else if(selectedBinding == 'hand'){
      //price += handBindingPrice;
      price += (hand_stitch_total / 100);
    }

    if(selectedBacking && selectedBacking != backingIncluded){
      fbyBackingQty = mqMath.backingUnits(width, height);

      //var backingCost = selectedBacking.price * yards / 100;
      // `price` here is a string, in cents. So, parseInt then divide by 100 to get dollars. price represents quarter yard, so use fbyBackingQty
      var backingCost = parseInt(selectedBacking.price) * fbyBackingQty / 100;

      price += backingCost;

    } else if (selectedBacking) {
      // Check back stitching options
      if(selectedStitching == "yes"){
        price += backStitchingPrice;
      }
    }

    // Rush the MQ order for an extra charge; between $25 and $50 based on size.
    //var expCost = quilt_sq_in * .005;
    var expCost = mqMath.areaUnits(width, height) * priority_price;
    if (quilt_sq_in < 5000) expCost = 25;
    //if (expressCost > 5000) expressCost = 50; // TODO: do we want this upper limit anymore?

    // Set the price explicitly in the checkbox label.
    $('#expedite-cost').html(' for $' + expCost.toFixed(2));
    if ($('#expedite').is(':checked')) {
      selectedExpOption = true;
      if(priority_free === false) price += expCost;
    } else {
      selectedExpOption = false;
    }

    pattern_is_discounted = false;
    // pattern magic
    if(patternDiscount && selectedPattern && selectedPattern.type === 'deluxe'){
      var selectedThemes = selectedPattern.themes.split(',');

      selectedThemes.every(i => {
        if(patternDiscountThemes.split(',').includes(i.trim())) {
          pattern_is_discounted = true;
          return false;
        }

        return true;
      });
    }

    // free deluxeUpgrade
    if(deluxeUpgrade == false && pattern_is_discounted == false && selectedChuckDiscount == false && selectedPennyPattern == false || table_topper){
      var deluxe_price = Math.ceil((quilt_sq_in * .0025) * 100) / 100;

      if (selectedPattern && selectedPattern.type === 'deluxe'){
        price += deluxe_price;
      }
    }

    $(".current_price").html("$" + price.toFixed(2));
    $(".current_price_tag").removeClass("hidden");
  };

  /*
   * Backing must extend four inches beyond each side of the quilt.
   * Maximum quilt widths for 60/90/108-inch fabric are 52/82/100 inches; wider quilts (up to 118") get
   * two widths of 108-inch fabric seamed together.
   * Quilt cannot be bigger than 118” on both sides (Error: too large for the frame) Other side can be bigger, but ONE side has to be <= 118”
   *
   */

  // Let customer know to choose dimensions before displaying backing options if fields are empty

  if (!$("#width").val() || !$("#height").val()) {
    $("#backing-108").addClass("hidden");
    $("#backing-90").addClass("hidden");
    $("#backing-60").addClass("hidden");
    $("#backing-message, #backing-theme-select").addClass("hidden");
    $("#backing-error-message").removeClass("hidden");
  }

  function updateBackingOptions(){
    var width = +$("#width").val();
    var height = +$("#height").val();

      fbyBackingQty = mqMath.backingUnits(width, height);

      // show available backings based on calculated yardage of quilt
      $("li.backing-option").each(function() {
        var backingOptionQty = parseInt($(this).attr('data-qty'));
        if (backingOptionQty < fbyBackingQty) {
          $(this).addClass("hidden");
        } else {
          $(this).removeClass("hidden");
        }
        });

    if(!mqMath.valid(width, height)) {
      //don't show options and display error message
      $("#backing-108").addClass("hidden");
      $("#backing-90").addClass("hidden");
      $("#backing-60").addClass("hidden");
      $("#backing-message, #backing-theme-select").addClass("hidden");
      $("#backing-error-message").removeClass("hidden");

    } else if(Math.min(width, height) <= 52){
      // show all options
      $("#backing-108").removeClass("hidden");
      $("#backing-90").removeClass("hidden");
      $("#backing-60").removeClass("hidden");
      // clear any error
      $("#dimension-error").addClass("hidden");
      //show correct backing message
      $("#backing-message, #backing-theme-select").removeClass("hidden");
      $("#backing-error-message").addClass("hidden");
    } else if(Math.min(width, height) <= 82){
      // only show 90 & 108
      $("#backing-108").removeClass("hidden");
      $("#backing-90").removeClass("hidden");
      $("#backing-60").addClass("hidden");
      // clear any error
      $("#dimension-error").addClass("hidden");
      //show correct backing message
      $("#backing-message, #backing-theme-select").removeClass("hidden");
      $("#backing-error-message").addClass("hidden");
    } else if(width > 118 && height > 118){
      // show error message
      $("#dimension-error").removeClass("hidden");
      //show correct backing message
      $("#backing-message, #backing-theme-select").addClass("hidden");
      $("#backing-error-message").removeClass("hidden");
    } else {
      // only show 108 (seamed above 100")
      $("#backing-108").removeClass("hidden");
      $("#backing-90").addClass("hidden");
      $("#backing-60").addClass("hidden");
      // clear any error
      $("#dimension-error").addClass("hidden");
      //show correct backing message
      $("#backing-message, #backing-theme-select").removeClass("hidden");
      $("#backing-error-message").addClass("hidden");
    }

    $("#backing-message").text(mqMath.valid(width, height) && mqMath.seamed(width, height)
      ? "What backing would you like? Your quilt is wider than 100\u2033, so we'll seam two widths of 108\u2033 backing together."
      : "What backing would you like?");

    // If all there are no backings available for an option, show none available
    $(".backing-options-list").each(function () {
      if ($(this).children().length === 0) {
        $(this).append('<p>None Available</p>');
      }
    })
  };

  // BACK STITCHING SELECT
  $('input[type=radio][name=stitching]').change(function() {
    selectedStitching = this.value;
    updatePrice();
  });

  // EXPEDITED OPTION SELECT
  $('input[type=checkbox][name=expedite]').change(function() {
    selectedExpOption = this.checked;
    updatePrice();
  });

  // BINDING SELECTION
  $('input[type=radio][name=binding]').change(function() {
    if (this.value == 'hand') {
      $("#binding-detail").removeClass("hidden");
    } else {
      $("#binding-detail").addClass("hidden");
    }
    selectedBinding = this.value;
    updatePrice();
  });

  /* Validation
  var validPatternMsg = "Please select a valid Pattern<br>";
  var validDimensionsMsg = "Please enter valid dimensions for your quilt (width and height) in inches<br>";
  var validBattingMsg = "Please choose your Batting<br>";
  var validBackingMsg = "Please make a selection for Backing<br>";
  var validTermsAgree = "Please agree to the terms<br>";
  */
  function validate(width, height){
    var errMsg = "";
    if(!mqMath.valid(width, height)){
      errMsg = errMsg.concat(validDimensionsMsg);
    } else if(selectedPattern == null) {
      errMsg = errMsg.concat(validPatternMsg);
    //} else if(selectedBatting == null) {
    //  errMsg = errMsg.concat(validBattingMsg);
    } else if(selectedBacking == null || (selectedBacking !== backingIncluded && !mqMath.backingFits(width, height, selectedBacking.width, selectedBacking.inventory))) {
      errMsg = errMsg.concat(validBackingMsg);
    } else if(!document.getElementById('agree').checked) {
      errMsg = errMsg.concat(validTermsAgree);
    }

    return errMsg;
  };

  $( "#add-to-cart" ).click(function() {
    // disable the button once clicked to avoid adding a second quilt
    $(this).prop('disabled', true);
    // change text on button to show adding to cart
    $(this).find('span.add_btn_label').text('Adding to cart...');
    $(this).find('svg').addClass('animate-spin');

    var width = +$("#width").val();
    var height = +$("#height").val();

    var errMsg = validate(width, height);
    var backingComments = $.trim($('#backing-textarea').val()) != "" ? $.trim($('#backing-textarea').val()).replace(/[^\x00-\x7F]/g, "") : "None";
    var bComments = $.trim($('#binding-textarea').val()) != "" ? $.trim($('#binding-textarea').val()).replace(/[^\x00-\x7F]/g, "") : "None";
    var backingYardage  = fbyBackingQty/4;
    // only a backing we supply is seamed; "I'm including my own backing" is always "No"
    var backingSeamed = selectedBacking && selectedBacking !== backingIncluded && mqMath.seamed(width, height) ? 'Yes, two widths' : 'No';
    var backStitchingInc = selectedBacking == backingIncluded && selectedStitching == "yes";
    var additionalComments = $.trim($('#comment-textarea').val()) ? $.trim($('#comment-textarea').val()).replace(/[^\x00-\x7F]/g, "") : "None";
    var social_contact = selectedSocialSharing ? $('#social_contacts').val() : selectedSocialSharing;

    var items = [];

    if(errMsg == ""){
      // if sq in less than 1000 set calculate quantity to meet table_topper_price
      selected_productId = productId;
      base_qty = mqMath.areaUnits(width, height);
      
      if(selectedPennyPattern) {
        selected_productId = pennyId;
        base_qty = mqMath.areaUnits(width, height);
      }

      if(selectedChuckDiscount) {
        selected_productId = twocentId;
        base_qty = mqMath.areaUnits(width, height);
      }
      
      // no discounts for table topper
      if(table_topper){
        selected_productId = table_topperId;
        base_qty = 1;
      }

      // baseline MQ cost, at .03/sq inch:
      items.push({
        quantity: base_qty,
        id: selected_productId, // value cost, 3 cents / sq in
        //line: 1,
        properties: {
          'MQ ID': mq_order_id,
          'MQ Note' : 'For MQ order',
          'MQ Rush': selectedExpOption,
          'MQ Deluxe': selectedDeluxePattern,
          'MQ Pattern': selectedPattern.name,
          'MQ Thread': selectedThread.name,
          //'MQ Batting' : selectedBatting.name,
          'MQ Backing' : (selectedBacking.name) ? selectedBacking.name : selectedBacking,
          'MQ BackingYardage': backingYardage,
          'MQ Backing Seamed': backingSeamed,
          'MQ BackingComments': backingComments,
          'MQ BackStitching' : backStitchingInc ? "yes" : "no",
          'MQ Binding': selectedBinding,
          'MQ BindingComments' :    bComments,
          'MQ Sharing': selectedSocialSharing,
          'MQ Social': social_contact,
          'MQ AdditionalComments' : additionalComments,
          'MQ Width (inches)' : width,
          'MQ Height (inches)' : height
        }
      });

      // if expedited, use one of the expedited variants (minimum priority $25: 34867762626693, priority 7 cents/2 sq in: 34861283934341)
      if(selectedExpOption && priority_free == false){
        // 5,000 sq in and above is going to be over the $25 minimum, and therefore priced per 2 sq inches (7 cents)
        var sqInches = width * height;

        // minimum ($25) priority cost
        if(sqInches < 5000) {
          items.push({
            quantity: 1,
            id: priorityMinId, // minimum $25 priority charge
            //line: 1,
            properties: {
              'MQ ID': mq_order_id,
              'MQ Note' : 'For MQ order',
              'MQ Width (inches)' : width,
              'MQ Height (inches)' : height
            }
          });

        } else {
          // priority option, priced per 2 sq inches (because Shopify doesn't support fractional cents like $.005/sq inch)
          var qty = mqMath.areaUnits(width, height);

          items.push({
            quantity: qty ,
            id: priorityId, // priority cost, 7 cents / 2 sq inches
            //line: 1,
            properties: {
              'MQ ID': mq_order_id,
              'MQ Pattern': selectedPattern.name,
              'MQ Thread': selectedThread.name,
              //'MQ Batting' : selectedBatting.name,
              'MQ Backing' : selectedBacking.name,
              'MQ BackingComments': backingComments,
              'MQ Binding': selectedBinding,
              'MQ BindingComments' : bComments,
              'MQ AdditionalComments' : additionalComments,
              'MQ Width (inches)' : width,
              'MQ Height (inches)' : height
            }
          });
        }

      } // END Priority/selectedExpOption

      // add deluxe pattern line item when a deluxe pattern selected and not other pattern discount is running
      if(deluxeUpgrade == false && pattern_is_discounted == false && selectedChuckDiscount == false && selectedPennyPattern == false || table_topper) {
        if(selectedPattern && selectedPattern.type === 'deluxe'){
          items.push({
            quantity: Math.ceil(width * height / 4),
            id: deluxeId, // FBY variant id
            properties: {
              'MQ ID': mq_order_id,
              'MQ Note' : 'For MQ order',
              'MQ Pattern' : selectedPattern.name,
              'MQ Width' : width,
              'MQ Height' : height
            }
          })
        }
      }

      if(selectedThread.type == 'variegated') {
        items.push({
          quantity: 1,
          id: variegatedId,
          properties: {
            'MQ ID': mq_order_id,
            'MQ Note' : 'For MQ order',
            'MQ Thread' : selectedThread.name + ' Variegated'
          }
        });
      }

      // Add additional cost item: Pattern - BUSINESS DECISION: NOT FOR LAUNCH
      // if(selectedPattern.price > 0){
      //   items.push({
      //     quantity: width * height,
      //     id: selectedPattern.variantId, // FBY variant id
      //     properties: {
      //       'MQ ID': mq_order_id,
      //       'MQ Note' : 'For MQ order',
      //       'MQ Backing' : selectedPattern.name,
      //       'MQ Width' : width,
      //       'MQ Height' : height
      //     }
      //   });
      // }

      // Add additional cost item: Backing (FBY)
      if(selectedBacking.price && fbyBackingQty > 0){
        items.push({
          quantity: fbyBackingQty,
          id: selectedBacking.variantId, // FBY variant id
          properties: {
            'MQ ID': mq_order_id,
            'MQ Note' : 'For MQ order',
            'MQ Backing' : selectedBacking.name,
            'MQ BackingYardage': backingYardage,
            'MQ Backing Seamed': backingSeamed,
            'MQ Width (inches)' : width,
            'MQ Height (inches)' : height
          }
        });
      }


      // Add additional cost item: Back Stitching
      if(backStitchingInc){
        items.push({
          quantity: 1,
          id: backStitchingId, // back stitching variant id
          properties: {
            'MQ ID': mq_order_id,
            'MQ Note' : 'For MQ order',
            'MQ BackStitching' : selectedStitching,
            'MQ Width (inches)' : width,
            'MQ Height (inches)' : height
          }
        });
      }


      // Add additional cost item: Binding (if 'machine' or 'hand' or simply 'trim')
      if(selectedBinding == 'trim'){

        items.push({
          quantity: 1,
          id: trimBindingId,
          properties: {
            'MQ ID': mq_order_id,
            'MQ Note' : 'For MQ order',
            'MQ Binding' : selectedBinding,
            'MQ Width (inches)' : width,
            'MQ Height (inches)' : height
          }
        });

      } else if(selectedBinding == 'machine' || selectedBinding == 'hand') {
        var qty = mqMath.bindingUnits(width, height, selectedBinding, bindingDiscount);
        let bindingId = selectedBinding == 'machine' ? machineBindingId : selectedBinding == 'hand' ? handBindingId : '';

        items.push({
          quantity: qty,
          id: bindingId,
          properties: {
            'MQ ID': mq_order_id,
            'MQ Note' : 'For MQ order',
            'MQ Binding' : selectedBinding,
            'MQ Width (inches)' : width,
            'MQ Height (inches)' : height
          }
        });

      }

      $('input.mq_addon').each(function(){
        if($(this).is(':checked')){
          items.push({
            quantity: 1,
            id: $(this).data('variant-id'),
            properties: {
              'MQ ID': mq_order_id,
              'MQ Note' : `For MQ order`
            }
          });
        }
      });

      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          // every line of a quilt order carries 'MQ ID', so this catches all quilt types
          // (MQ-ORDER, MQ-PENNY, MQ-TWOCENT, MQ-TABLETOPPER) and their add-ons
          var hasMQOrder = cart.items.some(function (item) {
              return item.properties && item.properties['MQ ID'];
          });
          if (hasMQOrder) {
              // only one quilt order per cart; checkout validation enforces this too
              $("#success").html("");
              $("#error").html("You already have a machine quilting order in your cart. Please check out or remove it before starting another. <a href='/cart' class='underline'>View Cart</a>");
              enableAddToCartButton();
          } else {
              // Add all MQ product items in one call for it to work
              $.post('/cart/add.js', {
                  items: items
                }, null, 'json').done(function(response) {
                // clear any error message that may be around
                $("#error").html("");
        
                // add success message
                $("#success").html("Added to cart!  <a href='/cart' class='underline'>View Cart</a>");
                try {
                  //gtag('event', 'MQ added to cart');  
                } catch (err) {
                  console.error(err)
                }
                
                location.reload();
                window.location.assign("/cart");
              }).fail(function(error){
                  errMsg = "Sorry! Your order couldn't be added to your cart. Chances are something is out of stock for your quilt size. <br><br> Error Code: ";
                  errMsg = errMsg.concat(JSON.parse(error.responseText).description);
                   $("#error").html(errMsg);
                   enableAddToCartButton();
              });
          }
      }).catch(function (err) {
          console.error(err);
          $("#error").html("Sorry! We couldn't check your cart. Please try again.");
          enableAddToCartButton();
      });
    } else {
      $("#error").html(errMsg);
      enableAddToCartButton();
    }

  });

  $('.prev_step').click(function(){
    mq_glide.go('<');
  });

  $('.next_step').click(function(){
    mq_glide.go('>');
  });

  function enableAddToCartButton() {
    // re-enable the button 
    $('#add-to-cart').prop('disabled', false);
    // change text on button to show add to cart
    $('#add-to-cart').find('span.add_btn_label').text('Add to cart');
    $('#add-to-cart').find('svg').removeClass('animate-spin');
  }

  function getPropertyString(selectedProp){
    var label = selectedProp.name;
    if(selectedProp.price){
      label = label.concat(" (extra $)");
    }
    return label;
  };
});
